module.exports = __webpack_public_path__ + "img/icon-withdraw.12a4b55.svg";